import React, { useState } from 'react';
import { useUID } from 'react-uid';
import { useSpring, animated } from 'react-spring';
import useMeasure from '../../hooks/useMeasure';
import { StyledDiv, StyledQ, StyledA } from './styles';

const AnimatedA = animated(StyledA);

const Question = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [ref, { height }] = useMeasure();
  const uid = useUID();
  const accordionSpring = useSpring({ height: isOpen ? height : 0 });
  const toggleOpen = () => setIsOpen(!isOpen);
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') toggleOpen();
  };

  return (
    <StyledDiv aria-expanded={isOpen}>
      <StyledQ
        id={`question-${uid}`}
        role="tab"
        tabIndex="0"
        aria-controls={`answer-${uid}`}
        aria-expanded={isOpen}
        onClick={toggleOpen}
        onKeyPress={handleKeyPress}
      >
        {title}
        <div className="arrow" />
      </StyledQ>
      <AnimatedA
        id={`answer-${uid}`}
        role="tabpanel"
        aria-labelledby={`question-${uid}`}
        aria-hidden={!isOpen}
        style={{ ...accordionSpring }}
      >
        <div ref={ref}>
          <div>{children}</div>
        </div>
      </AnimatedA>
    </StyledDiv>
  );
};
export default Question;
